(function(){
  function ready(fn){ if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  ready(function(){
    var root=document.querySelector('[data-rpm-explorar]');
    if(!root) return;
    var dataNode=document.getElementById('rpm-explore-data');
    if(!dataNode) return;
    var data={};
    try{ data=JSON.parse(dataNode.textContent||'{}'); }catch(e){ console.error(e); return; }

    var CATEGORIES=Array.isArray(data.categories)?data.categories:[];
    var PRODUCTS=Array.isArray(data.products)?data.products:[];
    var B2B_PCT=Number(data.b2b_pct||0);
    var HERO_DEFAULT=data.hero_default||'';
    var HERO_MOT=data.hero_mot||'';

    function esc(str){ return String(str==null?'':str).replace(/[&<>"']/g, function(s){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[s]; }); }
    function normalize(str){ return String(str||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim(); }

    /* ── Brand canonicalization: maps any variant to a single canonical name ── */
    var BRAND_ALIASES = {
      'mercedes': 'Mercedes-Benz',
      'mercedes-benz': 'Mercedes-Benz',
      'mercedes benz': 'Mercedes-Benz',
      'mb': 'Mercedes-Benz',
      'volkswagen': 'Volkswagen',
      'vw': 'Volkswagen',
      'land rover': 'Land Rover',
      'land-rover': 'Land Rover',
      'landrover': 'Land Rover',
      'audi': 'Audi',
      'bmw': 'BMW',
      'citroen': 'Citroen',
      'citroën': 'Citroen',
      'dacia': 'Dacia',
      'fiat': 'Fiat',
      'ford': 'Ford',
      'honda': 'Honda',
      'hyundai': 'Hyundai',
      'iveco': 'Iveco',
      'kia': 'Kia',
      'lexus': 'Lexus',
      'nissan': 'Nissan',
      'opel': 'Opel',
      'peugeot': 'Peugeot',
      'renault': 'Renault',
      'seat': 'SEAT',
      'skoda': 'Skoda',
      'škoda': 'Skoda',
      'toyota': 'Toyota',
      'chevrolet': 'Chevrolet'
    };
    function canonBrand(name){
      if(!name) return name;
      var key = String(name).trim().toLowerCase();
      return BRAND_ALIASES[key] || String(name).trim();
    }

    /* Pre-process product brand data so all downstream code sees canonical brands */
    PRODUCTS.forEach(function(p){
      if(p.marcas && p.marcas.length){
        var seen = {};
        var out = [];
        p.marcas.forEach(function(b){
          var c = canonBrand(b);
          var k = c.toLowerCase();
          if(!seen[k]){ seen[k] = true; out.push(c); }
        });
        p.marcas = out;
      }
      if(p.modelos && p.modelos.length){
        p.modelos = p.modelos.map(function(o){ return o ? { b: canonBrand(o.b), v: o.v } : o; });
      }
      if(p.versiones && p.versiones.length){
        p.versiones = p.versiones.map(function(o){ return o ? { b: canonBrand(o.b), v: o.v } : o; });
      }
    });
    function money(cents){ return new Intl.NumberFormat('es-ES',{style:'currency',currency:'EUR'}).format((Number(cents)||0)/100); }
    function getCategory(code){ for(var i=0;i<CATEGORIES.length;i++){ if(CATEGORIES[i].code===code) return CATEGORIES[i]; } return null; }
    function getCatName(code){ var cat=getCategory(code); return cat ? cat.label : (code || 'Sin categoría'); }
    var CATEGORY_CODE_BY_NORM = {};
    CATEGORIES.forEach(function(cat){
      CATEGORY_CODE_BY_NORM[normalize(cat.code)] = cat.code;
      CATEGORY_CODE_BY_NORM[normalize(cat.label)] = cat.code;
    });
    function resolveCategoryCode(value){
      return CATEGORY_CODE_BY_NORM[normalize(value)] || '';
    }
    function parseTypeValue(value, fallbackCat){
      var raw = String(value || '').trim();
      var fallbackCode = resolveCategoryCode(fallbackCat) || String(fallbackCat || '').trim();
      if(!raw) return { raw:'', cat:fallbackCode, label:'' };
      if(raw.indexOf('|') !== -1){
        var parts = raw.split('|');
        var left = (parts.shift() || '').trim();
        var right = parts.join('|').trim();
        var resolved = resolveCategoryCode(left);
        if(resolved && right){
          return { raw: resolved + '|' + right, cat: resolved, label: right };
        }
      }
      return { raw: raw, cat: fallbackCode, label: raw };
    }
    function rawTypeValue(value, fallbackCat){
      var parsed = parseTypeValue(value, fallbackCat);
      return parsed.cat && parsed.label ? (parsed.cat + '|' + parsed.label) : parsed.raw;
    }
    function visibleType(value, fallbackCat){
      var parsed = parseTypeValue(value, fallbackCat);
      return parsed.label || parsed.raw;
    }
    function sameType(productType, selectedType, fallbackCat){
      if(!selectedType) return true;
      var a = parseTypeValue(productType, fallbackCat);
      var b = parseTypeValue(selectedType, fallbackCat);
      if(b.cat && a.cat && normalize(a.cat) !== normalize(b.cat)) return false;
      return normalize(a.label || a.raw) === normalize(b.label || b.raw);
    }
    function getCondLabel(code){ return ({NW:'Nuevo',RC:'Reconstruido',US:'Usado',UX:'Sin garantía'})[code] || code || 'Usado'; }
    function getCondClass(code){ return ({NW:'nw',RC:'rc',US:'us',UX:'us'})[code] || 'us'; }
    function getB2B(cents){ var n=Number(cents)||0; return B2B_PCT>0 ? Math.round(n*(1-B2B_PCT/100)) : n; }
    function placeholder(code){ return '<span class="exp-item-ph" data-load-ic="'+esc(code||'DEF')+'"></span>'; }
    function hydrateIcons(scope){ var box=document.getElementById('rpm-icons-v2'); if(!box) return; (scope||document).querySelectorAll('[data-load-ic]').forEach(function(el){ var code=el.getAttribute('data-load-ic')||'DEF'; var src=box.querySelector('[data-ic="'+code+'"]') || box.querySelector('[data-ic="DEF"]'); if(src) el.innerHTML=src.innerHTML; }); }
    function wishlistButton(p){
      return '<button type="button" class="rpm-wishlist-btn rpm-wishlist-btn--overlay rpm-wishlist-btn--explore" data-rpm-wishlist-btn data-product-id="'+esc(p.id)+'" data-product-url="'+esc(p.u)+'" data-product-title="'+esc(p.t)+'" data-product-image="'+esc(p.img||'')+'" data-product-price="'+esc(money(p.p))+'" data-product-variant-id="'+esc(p.vid||'')+'" data-product-category="'+esc(p.cat||'')+'" data-product-type="'+esc(p.type||'')+'" data-product-condition="'+esc((p.cond||'US'))+'" data-product-available="'+(p.av?'true':'false')+'" title="Guardar producto" aria-label="Guardar producto"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35Z" stroke-linecap="round" stroke-linejoin="round"></path></svg><span class="visually-hidden" data-rpm-wishlist-label>Guardar</span></button>';
    }

    /* ── Helper: detect if a product has brand-prefixed data ─────────── */
    function hasBrandPrefix(arr){
      return (arr||[]).some(function(o){ return o && o.b && String(o.b).trim() !== ''; });
    }
    function modelosFor(p, brand){
      var arr = (p.modelos || []).filter(function(o){ return o && o.v; });
      if(!brand) return arr.map(function(o){ return o.v; });
      var nb = normalize(brand);
      /* If the product has brand prefixes, filter strictly */
      if(hasBrandPrefix(p.modelos)){
        return arr.filter(function(o){ return normalize(o.b||'') === nb; }).map(function(o){ return o.v; });
      }
      /* Legacy data without prefixes: only return models if the brand
         is actually one of this product's brands */
      var prodBrandsNorm = (p.marcas||[]).map(normalize);
      if(prodBrandsNorm.indexOf(nb) === -1) return [];
      return arr.map(function(o){ return o.v; });
    }
    function versionesFor(p, brand){
      var arr = (p.versiones || []).filter(function(o){ return o && o.v; });
      if(!brand) return arr.map(function(o){ return o.v; });
      var nb = normalize(brand);
      if(hasBrandPrefix(p.versiones)){
        return arr.filter(function(o){ return normalize(o.b||'') === nb; }).map(function(o){ return o.v; });
      }
      var prodBrandsNorm = (p.marcas||[]).map(normalize);
      if(prodBrandsNorm.indexOf(nb) === -1) return [];
      return arr.map(function(o){ return o.v; });
    }

    function generationsFor(p, brand){
      var arr = (p.generaciones || []).filter(function(o){ return o && o.v; });
      if(!brand) return arr.map(function(o){ return o.v; });
      var nb = normalize(brand);
      if(hasBrandPrefix(p.generaciones)){
        return arr.filter(function(o){ return normalize(o.b||'') === nb; }).map(function(o){ return o.v; });
      }
      var prodBrandsNorm = (p.marcas||[]).map(normalize);
      if(prodBrandsNorm.indexOf(nb) === -1) return [];
      return arr.map(function(o){ return o.v; });
    }
    function inferYearsFromText(text){
      var matches = String(text || '').match(/(?:19|20)\d{2}/g) || [];
      if(!matches.length) return '';
      var years = matches.map(function(v){ return Number(v); }).filter(function(v){ return !isNaN(v); }).sort();
      if(!years.length) return '';
      return years[0] + '-' + years[years.length - 1];
    }
    function yearRangeFromCandidates(candidates){
      var cleaned = [];
      var seen = {};
      (candidates || []).forEach(function(item){
        var value = String(item || '').trim();
        if(!value) return;
        if(seen[value]) return;
        seen[value] = true;
        cleaned.push(value);
      });
      if(!cleaned.length) return '';
      if(cleaned.length === 1) return cleaned[0];
      var years = [];
      cleaned.forEach(function(value){
        var parts = value.match(/(?:19|20)\d{2}/g) || [];
        parts.forEach(function(part){ years.push(Number(part)); });
      });
      years = years.filter(function(v){ return !isNaN(v); }).sort();
      if(!years.length) return cleaned[0];
      return years[0] + '-' + years[years.length - 1];
    }
    function fitmentYearMatches(p, brand, model, version){
      var rows = [];
      var maxLen = Math.max((p.modelos||[]).length, (p.versiones||[]).length, (p.generaciones||[]).length);
      for(var i=0;i<maxLen;i++){
        var mo = (p.modelos||[])[i] || {};
        var ve = (p.versiones||[])[i] || {};
        var ge = (p.generaciones||[])[i] || {};
        var rowBrand = canonBrand(mo.b || ve.b || ge.b || '');
        var rowModel = mo.v || '';
        var rowVersion = ve.v || '';
        var rowGeneration = ge.v || '';
        if(brand && normalize(rowBrand) !== normalize(brand)) continue;
        if(model && rowModel && normalize(rowModel) !== normalize(model)) continue;
        if(version && rowVersion && normalize(rowVersion) !== normalize(version)) continue;
        if(rowGeneration) rows.push(rowGeneration);
      }
      return rows;
    }
    function inferSelectedGeneration(){
      var candidates = [];
      filtered().forEach(function(p){
        candidates = candidates.concat(fitmentYearMatches(p, state.marca, state.modelo, state.version));
        if(!candidates.length){
          var rowYears = inferYearsFromText([p.t, p.h].join(' '));
          if(rowYears) candidates.push(rowYears);
        }
      });
      return yearRangeFromCandidates(candidates);
    }
    /* When listing brands for the marca dropdown, only show brands that
       actually have a matching model/version (when those filters are active) */
    function marcasFor(p){
      var brands = (p.marcas || []).slice();
      if(!state.modelo && !state.version) return brands;
      var nm = normalize(state.modelo);
      var nv = normalize(state.version);
      var modHasPrefix = hasBrandPrefix(p.modelos);
      var verHasPrefix = hasBrandPrefix(p.versiones);
      return brands.filter(function(b){
        var nb = normalize(b);
        if(state.modelo){
          if(modHasPrefix){
            var mods = (p.modelos||[]).filter(function(o){ return o && o.v && normalize(o.b||'')===nb; });
            if(!mods.some(function(o){ return normalize(o.v)===nm; })) return false;
          } else {
            /* Legacy: any model in product with matching value (any brand of product) */
            if(!(p.modelos||[]).some(function(o){ return o && o.v && normalize(o.v)===nm; })) return false;
          }
        }
        if(state.version){
          if(verHasPrefix){
            var vers = (p.versiones||[]).filter(function(o){ return o && o.v && normalize(o.b||'')===nb; });
            if(!vers.some(function(o){ return normalize(o.v)===nv; })) return false;
          } else {
            if(!(p.versiones||[]).some(function(o){ return o && o.v && normalize(o.v)===nv; })) return false;
          }
        }
        return true;
      });
    }

    var params=new URLSearchParams(location.search);
    var state={
      cat:(params.get('cat')||'').toUpperCase().trim(),
      marca:canonBrand((params.get('marca')||'').trim()),
      modelo:(params.get('modelo')||'').trim(),
      version:(params.get('version')||'').trim(),
      type:(params.get('type')||'').trim(),
      q:(params.get('q')||'').trim(),
      sort:'default',
      view:localStorage.getItem('rpmExploreView')||'list',
      visible:18
    };
    if(window.innerWidth<=900) state.view='list';
    if(state.cat && !getCategory(state.cat)) state.cat='';

    var els={
      title:root.querySelector('#expTitle'), sub:root.querySelector('#expSub'), heroTag:root.querySelector('#expHeroTag'), heroImg:root.querySelector('#expHeroImg'), bcExtra:root.querySelector('#expBcExtra'), heroCount:root.querySelector('#expHeroCount'), heroCountLabel:root.querySelector('#expHeroCountLabel'),
      search:root.querySelector('#expSearch'), clear:root.querySelector('#expSearchClear'), sort:root.querySelector('#expSort'),
      results:root.querySelector('#expResults'), grid:root.querySelector('#expGrid'), empty:root.querySelector('#expEmpty'),
      more:root.querySelector('#expMore'), moreBtn:root.querySelector('#expMoreBtn'),
      viewList:root.querySelector('#expViewList'), viewGrid:root.querySelector('#expViewGrid'),
      filterCat:root.querySelector('#expFilterCat'), filterMarca:root.querySelector('#expFilterMarca'),
      filterModelo:root.querySelector('#expFilterModelo'), filterVersion:root.querySelector('#expFilterVersion'),
      saveCar:root.querySelector('#expSaveCar')
    };
    if(els.search) els.search.value=state.q;

    function hasListMatch(list, selected){ if(!selected) return true; return (list||[]).some(function(item){ return normalize(item)===normalize(selected); }); }

    function matchesStateWithOmit(p, omit){
      omit = omit || {};
      if(!omit.cat && state.cat && p.cat!==state.cat) return false;
      if(!omit.type && state.type && !sameType(p.type, state.type, state.cat || p.cat)) return false;

      /* Brand-aware filtering: when marca + modelo (or version) are both
         set, the (brand, value) pair must exist together in the product */
      if(!omit.marca && state.marca){
        if(!hasListMatch(p.marcas, state.marca)) return false;
      }
      if(!omit.modelo && state.modelo){
        if(state.marca){
          /* Must have the model under the selected brand */
          if(!hasListMatch(modelosFor(p, state.marca), state.modelo)) return false;
        } else {
          /* No brand selected: any (b,v) pair where v matches is OK */
          var anyMod = (p.modelos||[]).some(function(o){ return o && o.v && normalize(o.v)===normalize(state.modelo); });
          if(!anyMod) return false;
        }
      }
      if(!omit.version && state.version){
        if(state.marca){
          if(!hasListMatch(versionesFor(p, state.marca), state.version)) return false;
        } else {
          var anyVer = (p.versiones||[]).some(function(o){ return o && o.v && normalize(o.v)===normalize(state.version); });
          if(!anyVer) return false;
        }
      }
      if(!omit.q && state.q){
        var q=normalize(state.q);
        var allModelos = (p.modelos||[]).map(function(o){ return o.v; });
        var allVersiones = (p.versiones||[]).map(function(o){ return o.v; });
        var hay=[p.t,p.s,p.ref,p.cat,p.type].concat(p.marcas||[]).concat(allModelos).concat(allVersiones).join(' ');
        if(normalize(hay).indexOf(q)===-1) return false;
      }
      return true;
    }
    function matchesState(p){ return matchesStateWithOmit(p, {}); }
    function filtered(){ return PRODUCTS.filter(matchesState); }
    function sortProducts(items){
      var arr=items.slice();
      switch(state.sort){
        case 'price-asc': arr.sort(function(a,b){ return (a.p||0)-(b.p||0); }); break;
        case 'price-desc': arr.sort(function(a,b){ return (b.p||0)-(a.p||0); }); break;
        case 'name-asc': arr.sort(function(a,b){ return String(a.t||'').localeCompare(String(b.t||''),'es',{sensitivity:'base'}); }); break;
        case 'name-desc': arr.sort(function(a,b){ return String(b.t||'').localeCompare(String(a.t||''),'es',{sensitivity:'base'}); }); break;
        default: arr.sort(function(a,b){ return (b.av===true)-(a.av===true); });
      }
      return arr;
    }

    function facetCounts(type, omit){
      /* Map from normalized key -> {label, count} so 'Mercedes' and 'Mercedes-Benz'
         can never coexist as separate options no matter what the data says */
      var map={};
      PRODUCTS.forEach(function(p){
        if(!matchesStateWithOmit(p, omit||{})) return;
        var values=[];
        if(type==='cat') values = p.cat ? [p.cat] : [];
        if(type==='type') values = p.type ? [{ value: rawTypeValue(p.type, p.cat), label: visibleType(p.type, p.cat) }] : [];
        if(type==='marca') values = marcasFor(p);
        if(type==='modelo') values = state.marca ? modelosFor(p, state.marca) : (p.modelos||[]).map(function(o){ return o.v; }).filter(Boolean);
        if(type==='version'){
          if(state.marca && state.modelo){
            var vs;
            if(hasBrandPrefix(p.versiones)){
              vs = (p.versiones||[]).filter(function(o){ return o && o.v && normalize(o.b||'')===normalize(state.marca); });
            } else {
              vs = (p.versiones||[]);
            }
            values = vs.map(function(o){ return o.v; }).filter(Boolean);
          } else if(state.marca){
            values = versionesFor(p, state.marca);
          } else {
            values = (p.versiones||[]).map(function(o){ return o.v; }).filter(Boolean);
          }
        }
        /* Apply brand canonicalization to brand values themselves, then
           dedupe per-product to avoid counting same value twice */
        if(type==='marca'){
          values = values.map(canonBrand);
        }
        var seen={};
        values.forEach(function(v){
          var value = v && typeof v === 'object' ? v.value : v;
          var label = v && typeof v === 'object' ? (v.label || v.value) : v;
          if(!value) return;
          var parsedType = type==='type' ? parseTypeValue(value, p.cat) : null;
          var k = normalize(type==='type' ? ((parsedType.cat || '') + '|' + (parsedType.label || label)) : value);
          if(seen[k]) return;
          seen[k] = true;
          if(!map[k]) map[k] = { value: value, label: label, count: 0 };
          map[k].count += 1;
        });
      });
      return Object.keys(map)
        .map(function(k){ return { value: map[k].value, label: map[k].label, count: map[k].count }; })
        .sort(function(a,b){ if(b.count!==a.count) return b.count-a.count; return a.value.localeCompare(b.value,'es',{sensitivity:'base'}); });
    }

    function buildUrl(overrides){
      var next={ cat:state.cat, type:state.type, marca:state.marca, modelo:state.modelo, version:state.version, q:state.q };
      Object.keys(overrides||{}).forEach(function(key){ next[key]=overrides[key]; });
      var query=new URLSearchParams();
      ['cat','type','marca','modelo','version','q'].forEach(function(key){ if(next[key]) query.set(key, next[key]); });
      var out=query.toString();
      return '/pages/explorar' + (out ? ('?'+out) : '');
    }
    function getCurrentFilterBadges(){
      var badges=[];
      if(state.marca) badges.push(state.marca);
      if(state.modelo) badges.push(state.modelo);
      if(state.version) badges.push(state.version);
      if(state.cat) badges.push(getCatName(state.cat));
      if(state.type) badges.push(visibleType(state.type, state.cat));
      if(state.q) badges.push('Búsqueda: ' + state.q);
      return badges;
    }
    function buildEmptyWhatsappHref(){
      var parts=['Hola, no encuentro esta pieza en la web de RPM Repuestos.'];
      if(state.marca) parts.push('Marca: ' + state.marca + '.');
      if(state.modelo) parts.push('Modelo: ' + state.modelo + '.');
      if(state.version) parts.push('Versión: ' + state.version + '.');
      if(state.cat) parts.push('Categoría: ' + getCatName(state.cat) + '.');
      if(state.type) parts.push('Subcategoría: ' + visibleType(state.type, state.cat) + '.');
      if(state.q) parts.push('Búsqueda: ' + state.q + '.');
      parts.push('¿Me ayudan a encontrar una alternativa compatible?');
      return 'https://wa.me/34610361774?text=' + encodeURIComponent(parts.join(' '));
    }
    function renderEmptyState(){
      if(!els.empty) return;
      var badges=getCurrentFilterBadges();
      var title = badges.length ? 'No encontramos esta pieza ahora mismo' : 'No encontramos resultados para esta búsqueda';
      var description = badges.length
        ? 'No hay stock publicado con esta combinación de vehículo, categoría o búsqueda. Escríbenos por WhatsApp y te buscamos una alternativa compatible.'
        : 'No hay resultados publicados con esta búsqueda. Escríbenos por WhatsApp y te ayudamos a localizar la pieza correcta.';
      var badgeHtml = badges.length ? badges.map(function(item){ return '<span class="exp-empty-card__chip">'+esc(item)+'</span>'; }).join('') : '<span class="exp-empty-card__chip">Asistencia personalizada</span>';
      els.empty.innerHTML = ''+
        '<article class="exp-empty-card">'+
          '<div class="exp-empty-card__media">'+
            '<div class="exp-empty-card__icon" aria-hidden="true">'+
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path stroke-linecap="round" stroke-linejoin="round" d="M4 11h16M7 16h1m8 0h1m-9 4h8a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3H8A3 3 0 0 0 5 9v8a3 3 0 0 0 3 3Z"></path></svg>'+
            '</div>'+
            '<div class="exp-empty-card__media-copy">'+
              '<span class="exp-empty-card__kicker">Búsqueda manual</span>'+
              '<strong>Te ayudamos por WhatsApp</strong>'+
              '<p>Unimos tus filtros, revisamos stock y te proponemos una pieza compatible.</p>'+
            '</div>'+
          '</div>'+
          '<div class="exp-empty-card__main">'+
            '<div class="exp-empty-card__badges">'+
              '<span class="exp-badge exp-badge--success">Atención directa</span>'+
              '<span class="exp-badge">Sin resultados publicados</span>'+
            '</div>'+
            '<h3 class="exp-empty-card__title">'+esc(title)+'</h3>'+
            '<p class="exp-empty-card__text">'+esc(description)+'</p>'+
            '<div class="exp-empty-card__chips">'+badgeHtml+'</div>'+
          '</div>'+
          '<div class="exp-empty-card__side">'+
            '<a href="'+buildEmptyWhatsappHref()+'" target="_blank" rel="noopener" class="exp-item-btn exp-item-btn--whatsapp">Pedir pieza por WhatsApp</a>'+
            '<a href="'+buildUrl({cat:'',type:'',marca:'',modelo:'',version:'',q:''})+'" class="exp-item-btn">Limpiar filtros</a>'+
          '</div>'+
        '</article>';
    }
    function syncUrl(){ if(history && history.replaceState) history.replaceState({},'',buildUrl({})); }

    function setOptions(select, items, placeholderTxt, selected){
      if(!select) return;
      var html='<option value="">'+esc(placeholderTxt)+'</option>';
      items.forEach(function(item){
        var value=item.value;
        var count=item.count;
        var label=item.label || value;
        html += '<option value="'+esc(value)+'"'+(normalize(selected)===normalize(value)?' selected':'')+'>'+esc(label)+(count?(' ('+count+')'):'')+'</option>';
      });
      select.innerHTML=html;
    }

    function uniqueByNormalize(items){
      var seen={};
      return (items||[]).filter(function(item){
        var value=String(item||'').trim();
        if(!value) return false;
        var key=normalize(value);
        if(seen[key]) return false;
        seen[key]=true;
        return true;
      });
    }

    /* ── Build merged Cat+Subcat dropdown using optgroups ────────────────── */
    function renderCatDropdown(){
      if(!els.filterCat) return;
      var html='<option value="">Todas las categorías</option>';
      CATEGORIES.forEach(function(cat){
        var types=(cat.types||[]).slice().sort(function(a,b){ return visibleType(a, cat.code).localeCompare(visibleType(b, cat.code),'es',{sensitivity:'base'}); });
        var catCount=Number(cat.count||0);

        if(types.length > 0){
          html += '<optgroup label="'+esc(cat.label)+'">';
          var allSel = state.cat===cat.code && !state.type;
          html += '<option value="CAT:'+esc(cat.code)+'"'+(allSel?' selected':'')+'>Todos · '+esc(cat.label)+(catCount ? ' ('+catCount+')' : '')+'</option>';
          var seenTypes = {};
          types.forEach(function(t){
            var optionValue = rawTypeValue(t, cat.code);
            var optionLabel = visibleType(t, cat.code);
            var dedupeKey = normalize(cat.code + '|' + optionLabel);
            if(seenTypes[dedupeKey]) return;
            seenTypes[dedupeKey] = true;
            var compositeVal = 'CAT:'+cat.code+'|TYPE:'+optionValue;
            var isSel = state.cat===cat.code && sameType(optionValue, state.type, cat.code);
            html += '<option value="'+esc(compositeVal)+'"'+(isSel?' selected':'')+'>'+esc(cat.label)+' · '+esc(optionLabel)+'</option>';
          });
          html += '</optgroup>';
        } else {
          var sel = state.cat===cat.code;
          html += '<option value="CAT:'+esc(cat.code)+'"'+(sel?' selected':'')+'>'+esc(cat.label)+(catCount ? ' ('+catCount+')' : '')+'</option>';
        }
      });
      els.filterCat.innerHTML = html;
    }

    function renderAdvancedFilters(){
      renderCatDropdown();

      var vehicleFacetOmit = { cat:true, type:true, q:true };
      var marcaItems = facetCounts('marca', Object.assign({ marca:true }, vehicleFacetOmit));
      setOptions(els.filterMarca, marcaItems, 'Todas las marcas', state.marca);
      if(els.filterMarca) els.filterMarca.disabled = !marcaItems.length;

      var modeloItems = facetCounts('modelo', Object.assign({ modelo:true }, vehicleFacetOmit));
      setOptions(els.filterModelo, modeloItems, state.marca ? 'Todos los modelos' : 'Selecciona antes una marca', state.modelo);
      if(els.filterModelo) els.filterModelo.disabled = !state.marca || !modeloItems.length;

      var versionItems = facetCounts('version', Object.assign({ version:true }, vehicleFacetOmit));
      setOptions(els.filterVersion, versionItems, state.modelo ? 'Todas las versiones' : 'Selecciona antes un modelo', state.version);
      if(els.filterVersion) els.filterVersion.disabled = !state.modelo || !versionItems.length;

      /* Reset stale selections only if they are invalid in the vehicle hierarchy itself.
         Category, subcategory or free-text searches must never clear the selected car. */
      if(state.marca && !marcaItems.some(function(item){ return normalize(item.value)===normalize(state.marca); })) state.marca='';
      if(state.modelo && !modeloItems.some(function(item){ return normalize(item.value)===normalize(state.modelo); })) state.modelo='';
      if(state.version && !versionItems.some(function(item){ return normalize(item.value)===normalize(state.version); })) state.version='';

      /* Show garaje save button only when there's at least one filter active */
      if(els.saveCar){
        var hasFilter = !!(state.marca || state.modelo || state.version || state.cat || state.type || state.q);
        els.saveCar.style.display = hasFilter ? 'inline-flex' : 'none';
      }
    }

    var HERO_COPY_BY_CATEGORY={
      MOT:{title:'Motores para tu vehículo',sub:'Encuentra motores completos y motores 3/4 filtrando por marca, modelo, versión y categoría para llegar antes al recambio adecuado.'},
      TUR:{title:'Turbos para coche',sub:'Consulta turbos y accesorios con filtros por vehículo y subcategoría para reducir errores y localizar antes la referencia correcta.'},
      CAJ:{title:'Cajas de cambio por vehículo',sub:'Filtra por marca, modelo y versión para ver solo cajas de cambio con más encaje para tu búsqueda.'},
      CUL:{title:'Culatas para coche',sub:'Una categoría pensada para encontrar culatas de forma más rápida y precisa, con filtros por vehículo y tipo de pieza.'},
      ELE:{title:'Recambios eléctricos',sub:'Alternadores, arranques, compresores y EGR con filtros más precisos por vehículo, versión y categoría.'},
      INY:{title:'Inyección y admisión',sub:'Bombas de inyección y colectores dentro de un buscador más claro para acertar antes con la pieza.'},
      OPT:{title:'Ópticas por marca, modelo y versión',sub:'Encuentra faros y pilotos filtrando por vehículo y subcategoría para ver opciones más relevantes.'}
    };
    function heroText(){
      var title='Explora por vehículo, versión y categoría';
      var sub='Usa los filtros de marca, modelo, versión y categoría para ver solo recambios con más encaje para tu coche.';
      var tag='Buscador mejorado';
      var img=HERO_DEFAULT;
      if(state.cat && HERO_COPY_BY_CATEGORY[state.cat]){ title=HERO_COPY_BY_CATEGORY[state.cat].title; sub=HERO_COPY_BY_CATEGORY[state.cat].sub; tag='Categoría'; if(state.cat==='MOT') img=HERO_MOT; }
      if(state.marca && state.modelo){ title='Repuestos para '+state.marca+' '+state.modelo; tag='Vehículo'; sub='Mostrando piezas filtradas por vehículo. Afina ahora por versión, categoría o subcategoría para quedarte solo con opciones más relevantes.'; }
      if(state.version){ title='Repuestos para '+[state.marca,state.modelo,state.version].filter(Boolean).join(' · '); tag='Versión'; sub='Resultados filtrados por versión concreta para reducir errores al buscar compatibilidades dentro del catálogo RPM.'; }
      if(state.type){ title=visibleType(state.type, state.cat) + (state.marca ? (' para '+state.marca) : ''); tag='Subcategoría'; }
      return {title:title, sub:sub, tag:tag, img:img};
    }
    function renderHero(){
      var h=heroText();
      if(els.title) els.title.textContent=h.title;
      if(els.sub) els.sub.innerHTML=esc(h.sub) + (state.q ? (' <strong>Búsqueda activa:</strong> '+esc(state.q)+'.') : '');
      if(els.heroTag) els.heroTag.textContent=h.tag;
      if(els.heroImg) els.heroImg.src=h.img;
      var crumbs=[]; [state.cat ? getCatName(state.cat) : '', state.type ? visibleType(state.type, state.cat) : '', state.marca, state.modelo, state.version].forEach(function(v){ if(v) crumbs.push(v); });
      if(els.bcExtra) els.bcExtra.textContent=crumbs.length ? (' / '+crumbs.join(' / ')) : '';
      var count=filtered().length;
      if(els.heroCount) els.heroCount.textContent=count;
      if(els.heroCountLabel) els.heroCountLabel.textContent = state.version || state.modelo || state.marca || ((state.type ? visibleType(state.type, state.cat) : '') || (state.cat ? getCatName(state.cat) : 'Piezas encontradas'));
    }

    function renderProducts(){
      var items=sortProducts(filtered());
      if(els.results) els.results.textContent=items.length+' productos';
      if(!items.length){ if(els.empty){ renderEmptyState(); els.empty.style.display='block'; } if(els.grid) els.grid.innerHTML=''; if(els.more) els.more.style.display='none'; return; }
      if(els.empty) els.empty.style.display='none';
      var visibleItems=items.slice(0, state.visible);
      var html='';
      visibleItems.forEach(function(p){
        var catName=getCatName(p.cat||'');
        var condCode=(p.cond||'US').toUpperCase();
        /* Display tags: brand, model, version (clean values) */
        var tagModelos = (p.modelos || []).map(function(o){ return o.v; });
        var tagVersiones = (p.versiones || []).map(function(o){ return o.v; });
        var tags = (p.marcas || []).concat(tagModelos).concat(tagVersiones.slice(0,1)).slice(0,4);
        var badges='<span class="exp-badge">'+esc(catName)+'</span>';
        if(p.type) badges += '<span class="exp-badge">'+esc(visibleType(p.type, p.cat))+'</span>';
        badges += '<span class="exp-badge exp-badge--cond '+getCondClass(condCode)+'">'+esc(getCondLabel(condCode))+'</span>';
        if(!p.av) badges += '<span class="exp-badge exp-badge--oos">Sin stock</span>';
        var oosTag = !p.av ? '<span class="exp-item-oos-tag">Sin stock</span>' : '';
        var media='<div class="exp-item-media-wrap'+(!p.av?' exp-item-media-wrap--oos':'')+'">'+((p.img ? '<a class="exp-item-media" href="'+esc(p.u)+'"><img src="'+esc(p.img)+'" alt="'+esc(p.t)+'" loading="lazy"></a>' : '<a class="exp-item-media" href="'+esc(p.u)+'">'+placeholder(p.cat||'DEF')+'</a>') + oosTag + wishlistButton(p))+'</div>';
        var waOosHref = 'https://wa.me/34610361774?text=' + encodeURIComponent('Hola, quiero pedir esta pieza aunque esté sin stock:\n' + p.t + '\n' + (p.s ? 'SKU: ' + p.s + '\n' : '') + 'https://rpmrepuestos.com' + p.u);
        var waSvg = '<svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413"/></svg>';
        var primaryBtn = p.av
          ? '<button type="button" class="exp-item-btn exp-item-btn--primary" data-vid="'+esc(p.vid)+'" data-product-category="'+esc(p.cat||'DEF')+'">Añadir al carrito</button>'
          : '<a class="exp-item-btn exp-item-btn--primary exp-item-btn--oos" href="'+waOosHref+'" target="_blank" rel="noopener">'+waSvg+'Pedir por WhatsApp</a>';
        var side='<div class="exp-item-side"><div><div class="exp-price">'+money(p.p)+'</div>'+(B2B_PCT>0?'<div class="exp-b2b"><small>Precio taller</small><strong>'+money(getB2B(p.p))+'</strong></div>':'')+'</div><div class="exp-actions">'+primaryBtn+'<a class="exp-item-btn" href="'+esc(p.u)+'">Ver ficha</a></div></div>';
        if(state.view==='grid'){
          html += '<article class="exp-item exp-item--grid exp-item--clickable" data-href="'+esc(p.u)+'" role="link" tabindex="0">'+media+'<div class="exp-item-main"><div class="exp-item-top">'+badges+'</div><h2 class="exp-item-title"><a href="'+esc(p.u)+'">'+esc(p.t)+'</a></h2><div class="exp-item-meta"><div class="exp-item-code">'+esc(p.s || p.ref || '')+'</div><div class="exp-item-tags">'+tags.map(function(m){ return '<span class="exp-item-tag">'+esc(m)+'</span>'; }).join('')+'</div></div></div>'+side+'</article>';
        } else {
          html += '<article class="exp-item exp-item--list exp-item--clickable" data-href="'+esc(p.u)+'" role="link" tabindex="0">'+media+'<div class="exp-item-main"><div class="exp-item-top">'+badges+'</div><h2 class="exp-item-title"><a href="'+esc(p.u)+'">'+esc(p.t)+'</a></h2><div class="exp-item-meta"><div class="exp-item-code">'+esc(p.s || p.ref || '')+'</div><div class="exp-item-desc">'+esc(tagModelos[0] || visibleType(p.type, p.cat) || catName)+' disponible dentro del catálogo RPM con filtros mejorados por vehículo y versión.</div><div class="exp-item-tags">'+tags.map(function(m){ return '<span class="exp-item-tag">'+esc(m)+'</span>'; }).join('')+'</div></div></div>'+side+'</article>';
        }
      });
      if(els.grid){
        els.grid.classList.toggle('is-grid', state.view==='grid');
        els.grid.classList.toggle('is-list', state.view!=='grid');
        els.grid.innerHTML=html;
        hydrateIcons(els.grid);
        if(window.rpmWishlist && typeof window.rpmWishlist.sync==='function'){ window.rpmWishlist.sync(els.grid); }
      }
      if(els.more) els.more.style.display = items.length > state.visible ? 'flex' : 'none';
    }

    function syncViewButtons(){ if(els.viewList) els.viewList.classList.toggle('is-active', state.view==='list'); if(els.viewGrid) els.viewGrid.classList.toggle('is-active', state.view==='grid'); }
    function toggleClear(){ if(els.clear) els.clear.style.display = state.q ? 'inline-flex' : 'none'; }
    function updateAll(){ renderAdvancedFilters(); renderHero(); renderProducts(); syncUrl(); }

    function saveCurrentVehicle(){
      var vehicle = {
        marca: state.marca,
        modelo: state.modelo,
        generacion: inferSelectedGeneration(),
        version: state.version,
        categoria: getCatName(state.cat||''),
        subcategoria: visibleType(state.type, state.cat),
        q: state.q
      };
      var saved = false;
      if(window.rpmGarage && typeof window.rpmGarage.add==='function'){
        saved = window.rpmGarage.add(vehicle);
      } else {
        try { localStorage.setItem('rpm_selected_vehicle', JSON.stringify(vehicle)); saved = true; } catch(e){}
      }
      /* Visual feedback on the button */
      if(els.saveCar){
        var label = els.saveCar.querySelector('.exp-save-car-inline__label');
        var originalText = label ? label.textContent : '';
        var originalColor = els.saveCar.style.color;
        var originalBorder = els.saveCar.style.borderColor;
        if(label){
          label.textContent = saved ? 'Guardado en Mi Garaje' : 'Ya estaba en Mi Garaje';
        }
        els.saveCar.style.color = 'var(--rpm-green, #059669)';
        els.saveCar.style.borderColor = 'var(--rpm-green-border, rgba(5,150,105,.2))';
        setTimeout(function(){
          if(label) label.textContent = originalText;
          els.saveCar.style.color = originalColor;
          els.saveCar.style.borderColor = originalBorder;
        }, 2200);
      }
    }

    /* ── Event listeners ─────────────────────────────────────────────────── */
    window.addEventListener('resize', function(){ if(window.innerWidth<=900 && state.view!=='list'){ state.view='list'; syncViewButtons(); renderProducts(); } });
    if(els.search) els.search.addEventListener('input', function(){ state.q=this.value.trim(); state.visible=18; toggleClear(); updateAll(); });
    if(els.clear) els.clear.addEventListener('click', function(){ state.q=''; if(els.search) els.search.value=''; state.visible=18; toggleClear(); updateAll(); });
    if(els.sort) els.sort.addEventListener('change', function(){ state.sort=this.value; renderProducts(); });
    if(els.moreBtn) els.moreBtn.addEventListener('click', function(){ state.visible += 18; renderProducts(); });
    if(els.viewList) els.viewList.addEventListener('click', function(){ state.view='list'; localStorage.setItem('rpmExploreView','list'); syncViewButtons(); renderProducts(); });
    if(els.viewGrid) els.viewGrid.addEventListener('click', function(){ state.view='grid'; localStorage.setItem('rpmExploreView','grid'); syncViewButtons(); renderProducts(); });

    if(els.grid){
      els.grid.addEventListener('click', function(e){
        var card = e.target.closest('.exp-item--clickable');
        if(!card) return;
        if(e.target.closest('a,button,input,select,textarea,label,[role="button"],.rpm-wishlist-btn,.rpm-wishlist-toggle,.exp-item-btn')) return;
        var href = card.getAttribute('data-href');
        if(href) window.location.href = href;
      });
      els.grid.addEventListener('keydown', function(e){
        if(e.key !== 'Enter' && e.key !== ' ') return;
        var card = e.target.closest('.exp-item--clickable');
        if(!card || e.target !== card) return;
        var href = card.getAttribute('data-href');
        if(href){ e.preventDefault(); window.location.href = href; }
      });
    }

    if(els.filterCat) els.filterCat.addEventListener('change', function(){
      var val = this.value;
      if(!val){ state.cat=''; state.type=''; }
      else if(val.indexOf('|TYPE:') !== -1){
        var parts = val.split('|TYPE:');
        state.cat = parts[0].replace('CAT:','').toUpperCase();
        state.type = parts.slice(1).join('|TYPE:');
      } else {
        state.cat = val.replace('CAT:','').toUpperCase();
        state.type = '';
      }
      state.visible=18; updateAll();
    });
    if(els.filterMarca) els.filterMarca.addEventListener('change', function(){ state.marca=this.value; state.modelo=''; state.version=''; state.visible=18; updateAll(); });
    if(els.filterModelo) els.filterModelo.addEventListener('change', function(){ state.modelo=this.value; state.version=''; state.visible=18; updateAll(); });
    if(els.filterVersion) els.filterVersion.addEventListener('change', function(){ state.version=this.value; state.visible=18; updateAll(); });
    if(els.saveCar) els.saveCar.addEventListener('click', saveCurrentVehicle);

    document.addEventListener('click', function(event){
      var button=event.target.closest('.exp-item-btn--primary[data-vid]');
      if(button && button.getAttribute('data-vid') && typeof window.rpmAddToCart==='function'){
        event.preventDefault();
        window.rpmAddToCart(button, button.getAttribute('data-vid'), { defaultText: 'Añadir al carrito' });
      }
    });

    toggleClear();
    syncViewButtons();
    updateAll();
  });
})();
